import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <>
      {/* Hero with full-width background image */}
      <section className="relative w-full min-h-[70vh] md:min-h-[80vh] flex items-center justify-center overflow-hidden" data-id="element-111">
        <img src="https://cdn.magicpatterns.com/uploads/5idYWf8xNNcDnsKcj1u8MN/4c3bbe9331169a46c221997450121b53.jpg" alt="Maternidad" className="absolute inset-0 w-full h-full object-cover" data-id="element-112" />
        <div className="absolute inset-0 bg-black/40" data-id="element-113"></div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center" data-id="element-114">
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-8 leading-tight uppercase tracking-wide" data-id="element-115">
            Hay un momento en el que empezás a dudar de todo…
          </h1>
          <p className="font-serif text-lg md:text-2xl text-white/90 mb-8 max-w-3xl leading-relaxed" data-id="element-116">
            A veces pasa antes de que nazca… cuando te preguntás si vas a saber
            qué hacer.
          </p>
          <p className="font-serif text-lg md:text-2xl text-white/90 mb-10 max-w-3xl leading-relaxed" data-id="element-117">
            Y a veces pasa después… cuando lo tenés en brazos y nada se siente
            tan claro como imaginabas.
          </p>
          <div className="space-y-4 text-white/85 text-base md:text-lg font-light mb-10 max-w-2xl leading-relaxed" data-id="element-118">
            <p data-id="element-119">
              Sentís que deberías saber… pero en realidad estás aprendiendo
              sobre la marcha.
            </p>
            <p data-id="element-120">Y mientras otras parecen seguras… vos no te sentís así.</p>
          </div>
        </div>
      </section>

      {/* Product presentation below hero */}
      <section className="w-full bg-white py-20 md:py-28 px-6" data-id="element-121">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-122">
          <p className="font-serif text-xl md:text-2xl text-charcoal-600 mb-8 max-w-2xl leading-relaxed" data-id="element-123">
            No necesitás hacerlo perfecto… pero sí entender qué está pasando.
          </p>

          <h3 className="font-serif md:text-3xl text-charcoal-600 mb-8 max-w-2xl text-[16px] font-[300]" data-id="element-124">
            "No es falta de amor… es falta de claridad"
          </h3>

          <div className="space-y-4 text-charcoal-500 text-base md:text-lg font-light mb-10 max-w-2xl leading-relaxed" data-id="element-125">
            <p data-id="element-126">No es que no puedas. No es que no estés preparada.</p>
            <p data-id="element-127">
              Es que estás atravesando algo completamente nuevo… y nadie te
              explicó cómo se siente realmente.
            </p>
            <p data-id="element-128">
              Te llenan de información… pero no te ayudan a entender lo que te
              pasa.
            </p>
            <p data-id="element-129">Te sentis abrumada y desordenada.</p>
            <p data-id="element-130"></p>
            <p data-id="element-131">Y ahí es donde empieza la duda.</p>
          </div>

          <p className="text-charcoal-400 text-sm md:text-base mb-4 tracking-wider uppercase font-light" data-id="element-132">
            Por eso creamos esta guia
          </p>

          <span className="text-warm-500 tracking-[0.3em] uppercase mb-8 text-[32px] font-[700]" data-id="element-133">
            Florecer
          </span>

          <a href="https://checkout.aulamater.online/cart/44073141076067:1" className="block w-full max-w-xs mx-auto mb-12 transition-opacity duration-500 hover:opacity-90" data-id="element-134">
            <img src="https://cdn.magicpatterns.com/uploads/aS8TEinEsRuS6MDLyNf5B7/349bf724-620e-463d-a804-95c66235b1b4.png" alt="Florecer Ebook" className="w-full h-auto" data-id="element-135" />
          </a>

          <p className="font-serif text-xl md:text-2xl text-charcoal-600 mb-10 max-w-2xl leading-relaxed" data-id="element-136">
            Una guía pensada para acompañarte en este momento… cuando todo es
            nuevo, confuso y nadie te explica las cosas como realmente se
            sienten. Donde vas a encontrar claridad, orden y respuestas simples
            para dejar de sentirte tan perdida.
          </p>

          <div className="space-y-4 text-charcoal-400 text-lg font-light mb-16 max-w-2xl leading-relaxed" data-id="element-137">
            <p data-id="element-138">Ser mamá no siempre se siente como lo imaginabas.</p>
            <p data-id="element-139">
              A veces aparecen dudas, cansancio… y la sensación de no saber si
              lo estás haciendo bien.
            </p>
            <p data-id="element-140">Y aunque todos opinan… nadie te explica realmente qué hacer.</p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-141">
            <CTAButton href="#compra" data-id="element-142">Acceder a la guía</CTAButton>
            <p className="text-charcoal-300 text-sm tracking-wider uppercase mt-2" data-id="element-143">
              $19.990 ARS · Acceso inmediato
            </p>
          </div>
        </div>
      </section>
    </>;
}